export default "__VITE_ASSET__IBXnuX1e__"